import React from "react";
import { Droplet, Sparkles, Shield, Heart, Award, Leaf, CheckCircle, Crown } from "lucide-react";
import { useApp } from "../context/AppContext";

const TrustBadges = () => {
  const { t } = useApp();
  const items = [
    { Icon: Droplet, label: t.badges.waterproof },
    { Icon: Heart, label: t.badges.hypo },
    { Icon: Crown, label: t.badges.gold18k },
    { Icon: Sparkles, label: t.badges.nickel },
    { Icon: Shield, label: t.badges.tuv },
    { Icon: Leaf, label: t.badges.sensitive },
    { Icon: Award, label: t.badges.reach },
    { Icon: CheckCircle, label: t.badges.lead },
  ];
  return (
    <section className="bg-white border-y border-[var(--champagne)]/40 py-12 lg:py-16" data-testid="trust-badges">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-6 lg:gap-4">
          {items.map(({ Icon, label }, i) => (
            <div key={i} className="flex flex-col items-center text-center reveal" style={{ animationDelay: `${i * 0.05}s` }}>
              <Icon className="w-7 h-7 text-[var(--gold-deep)] mb-3" strokeWidth={1.25} />
              <div className="text-[10px] tracking-[0.2em] uppercase text-[var(--noir)] leading-tight">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
